/**
 * Copyright IBM Corp. 2022, 2026
 */

import { Products } from '@web/product-meta'

/**
 * Maps legacy API to new v6
 * Swaps theme for product with the new acceptable values
 *
 * If we update the CMS to match the component API, we can remove this
 */

type HeroThemeOptions =
	| 'vagrant-blue'
	| 'terraform-purple'
	| 'vault-gray'
	| 'consul-pink'
	| 'nomad-green'

export function mapThemeToProduct(theme: HeroThemeOptions | Products) {
	return theme.split('-')[0]
}

export default function formatHeroData(data) {
	if (!data.theme) return data
	const { theme, ...rest } = data
	const product = mapThemeToProduct(theme) ?? 'hashicorp'
	return {
		product,
		...rest,
	}
}
